import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import logo from '../assets/images/logo.jpg'
import { useEffect, useRef } from "react";
// @ts-ignore
// import WOW from 'wowjs/dist/wow'
import { NavLink } from "react-router-dom";

function Header() {
    const navbarCollapseRef = useRef<HTMLDivElement | null>(null);
    const closeMenu = () => {
        const navbarCollapse = navbarCollapseRef.current;
        if (navbarCollapse && navbarCollapse.classList.contains("show")) {
            const toggler = document.querySelector<HTMLButtonElement>(".navbar-toggler");
            toggler?.click();
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => {
            window.removeEventListener('scroll', stickNavbar);
        };
    }, [])
    
    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            windowHeight > 45 ? $('.navbar').addClass('sticky-top shadow-sm') : $('.navbar').removeClass('sticky-top shadow-sm');
            windowHeight > 45 ?? $('.back-to-top').addClass('d-block');
        }
    };

    return ( 
        <div className="container-fluid position-relative p-0">
            <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
                <Link to="/" className="navbar-brand p-0">
                    <h1 className="m-0"><img src={logo} alt="GREhub logo" height={50}/></h1>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <FontAwesomeIcon icon="bars"/>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse" ref={navbarCollapseRef}>
                    <div className="navbar-nav ms-4 py-0">
                        <NavLink to="/" end caseSensitive className="nav-item nav-link" onClick={closeMenu}>خانه</NavLink>
                        <HashLink to="/#about" className="nav-item nav-link" onClick={closeMenu}>معرفی</HashLink>
                        <HashLink to="/#pricing" className="nav-item nav-link" onClick={closeMenu}>تعرفه ها</HashLink>
                        <NavLink to="/blog" end caseSensitive className="nav-item nav-link" onClick={closeMenu}>وبلاگ</NavLink>
                        <NavLink to="/contact" end caseSensitive className="nav-item nav-link" onClick={closeMenu}>درباره ما</NavLink>
                    </div>
                    <Link to="/login" className="btn btn-outline-danger py-2 px-4 ms-auto" onClick={closeMenu}>بخش آزمون ها</Link>
                </div>
            </nav>
        </div>
     );
}

export default Header;